import { useLogEvent } from "@app/neva/hooks";
import { ButtonTypes } from "@app/neva/models";
import { NEVA_HEAP_EVENTS } from "@app/neva/models/constants";

type UsePartnerInfoEventsType = {
  logButtonClickEvent: (buttonType: ButtonTypes) => void;
  logFormSubmitEvent: () => void;
};

export const usePartnerInfoEvents = (): UsePartnerInfoEventsType => {
  const { logEvent } = useLogEvent();

  const logButtonClickEvent = (buttonType: ButtonTypes) => {
    const eventAction =
      buttonType === ButtonTypes.ENTER_PARTNER_INFORMATION
        ? NEVA_HEAP_EVENTS.PARTNER_INFO_FORM_CLICK
        : NEVA_HEAP_EVENTS.PARTNER_INFO_FORM_CLICK_EDIT;

    logEvent({
      eventAction,
      eventLabel: "User Action",
    });
  };

  const logFormSubmitEvent = () => {
    logEvent({
      eventAction: NEVA_HEAP_EVENTS.PARTNER_INFO_FORM_SUBMIT,
      eventLabel: "User Action",
    });
  };

  return { logButtonClickEvent, logFormSubmitEvent };
};
